// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gestion-comptes {
  margin: 0 auto;
  width: 100%;
}

.gestion-comptes h1 {
  margin-bottom: 3rem;
}

/* Style spécifique pour assurer que le menu d'actions est correctement positionné */
.action-menu-container {
  position: relative;
  display: inline-block;
}

.action-options-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  z-index: 1000;
  padding: 5px 0;
  margin-top: 5px;
}

.user-name,
.user-email,
.commande-count,
.commande-value,
.user-role,
.creation-date {
  font-size: 1.4rem;
  color: #2C3948;
}

.user-role {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #2C3948;
  cursor: pointer;
}

.user-role span {
  text-decoration: underline;
}

.user-role .edit-icon {
  width: 1.6rem;
  height: 1.6rem;
  color: #DA7027;
}

.user-role:hover span {
  color: #DA7027;
}

.user-role:hover .edit-icon {
  color: #C4631F;
}

.gestion-comptes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

/* Styles pour le modal de changement de rôle */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.change-role-modal {
  background-color: #FFFDFC;
  padding: 2rem;
  border-radius: 0.8rem;
  min-width: 40rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.change-role-modal h2 {
  margin-bottom: 1rem;
}

.change-role-modal p {
  margin-bottom: 2rem;
  color: #6B7280;
}

.role-options {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.role-button {
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  border: 1px solid #E5E7EB;
  background-color: #FFFDFC;
  cursor: pointer;
  font-size: 1.4rem;
  transition: all 0.2s ease;
}

.role-button:hover {
  background-color: #F9FAFB;
}

.role-button.active {
  background-color: rgba(215, 217, 217, 0.20);
  border-color: #DBEAFE;
  color: #484848;
}

.role-button.selected {
  background-color: #FCF1E7;
  border-color: #DA7027;
  color: #DA7027;
  box-shadow: 0 0 0 1px #DA7027;
}

.role-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/composants/GestionComptes/GestionComptes.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;EAME,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".gestion-comptes {\r\n  margin: 0 auto;\r\n  width: 100%;\r\n}\r\n\r\n.gestion-comptes h1 {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n/* Style spécifique pour assurer que le menu d'actions est correctement positionné */\r\n.action-menu-container {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.action-options-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  min-width: 220px;\r\n  z-index: 1000;\r\n  padding: 5px 0;\r\n  margin-top: 5px;\r\n}\r\n\r\n.user-name,\r\n.user-email,\r\n.commande-count,\r\n.commande-value,\r\n.user-role,\r\n.creation-date {\r\n  font-size: 1.4rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.user-role {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8rem;\r\n  color: #2C3948;\r\n  cursor: pointer;\r\n}\r\n\r\n.user-role span {\r\n  text-decoration: underline;\r\n}\r\n\r\n.user-role .edit-icon {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  color: #DA7027;\r\n}\r\n\r\n.user-role:hover span {\r\n  color: #DA7027;\r\n}\r\n\r\n.user-role:hover .edit-icon {\r\n  color: #C4631F;\r\n}\r\n\r\n.gestion-comptes-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Styles pour le modal de changement de rôle */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.change-role-modal {\r\n  background-color: #FFFDFC;\r\n  padding: 2rem;\r\n  border-radius: 0.8rem;\r\n  min-width: 40rem;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.change-role-modal h2 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.change-role-modal p {\r\n  margin-bottom: 2rem;\r\n  color: #6B7280;\r\n}\r\n\r\n.role-options {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.role-button {\r\n  padding: 0.8rem 1.6rem;\r\n  border-radius: 0.4rem;\r\n  border: 1px solid #E5E7EB;\r\n  background-color: #FFFDFC;\r\n  cursor: pointer;\r\n  font-size: 1.4rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.role-button:hover {\r\n  background-color: #F9FAFB;\r\n}\r\n\r\n.role-button.active {\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n  border-color: #DBEAFE;\r\n  color: #484848;\r\n}\r\n\r\n.role-button.selected {\r\n  background-color: #FCF1E7;\r\n  border-color: #DA7027;\r\n  color: #DA7027;\r\n  box-shadow: 0 0 0 1px #DA7027;\r\n}\r\n\r\n.role-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
